import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import Landing from './pages/Landing';
import Guide from './pages/Guide';
import Masters from './pages/Masters';
import HalfYear from './pages/HalfYear';
import PlayerChallengeMatrix from './pages/PlayerChallengeMatrix';
import MasterChallengeMatrix from './pages/MasterChallengeMatrix';
import Events from './pages/Events';
import Movies from './pages/Movies';
import Players from './pages/Players';
import Memer from './pages/Memer';
import SearchGuide from './pages/SearchGuide';
import PeopleSearch from './pages/PeopleSearch';
import LangSwitcher from './components/LangSwitcher';

export default function App() {
  const location = useLocation();
  const hideLangSwitcher = location.pathname === "/memer" || location.pathname.indexOf("mega") > 0 || location.pathname.indexOf("beldum") > 0;
  
  return (
    <div className="app-shell">
      <div className="app-surface">
        <NavBar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/masters" element={<Masters />} />
          <Route path="/halfyear" element={<HalfYear />} />
          <Route path="/playerchallengematrix" element={<PlayerChallengeMatrix />} />
          <Route path="/mastersmatrix" element={<MasterChallengeMatrix />} />
          <Route path="/events" element={<Events />} />
          <Route path="/players" element={<Players />} />
          <Route path="/movies" element={<Movies />} />
          <Route path="/memer" element={<Memer />} />
          <Route path="/searchguide" element={<SearchGuide />} />
          <Route path="/peoplesearch" element={<PeopleSearch />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      {!hideLangSwitcher && <LangSwitcher />}
    </div>
  );
}
